// extracted by mini-css-extract-plugin
export var footer__content = "footer-module--footer__content--f65B+";
export var socialIcons = "footer-module--social-icons--UV39T";
export var hours = "footer-module--hours--tyRP4";
export var neonText = "footer-module--neon-text--SQXoF";
export var open = "footer-module--open--ZZcpJ";
export var closed = "footer-module--closed---qEZQ";